import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppAsideComponent } from './app-aside.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    AppAsideComponent
  ],
  declarations: [
    AppAsideComponent
  ]
})
export class AppAsideModule { }
